<template>
  <div class="relative">
    <div class="overflow-x-auto m-auto"
      :class="[navPosition == 'center' ? 'w-full lg:mx-0' : 'mx-5 lg:w-calc1 lg:mx-8']" id="taContainer">
      <div ref="itemsRef" class="flex pb-3.5 space-x-5 rtl:space-x-reverse pt-2.5"
        :class="[navPosition == 'center' ? 'tr:lg:pr-0 rtl:lg:pl-0' : 'tr:lg:pr-8 rtl:lg:pl-8']">
        <slot></slot>
      </div>
    </div>

    <div v-show="navPosition === 'center' && showNavigationBar && showArrows">
      <div @click="scrollLeft()" class="cursor-pointer absolute ltr:-left-6 rtl:-right-6 z-2"
        :style="`top: ${arrowsTopPixels}px`">
        <img class="h-10 w-10 md:h-12 md:w-12 rounded-full border border-blue-300 md:border-0 shadow-ts3"
          src="../../assets/img/previous-arrow-2.svg" />
      </div>

      <div @click="scrollRight()" class="cursor-pointer absolute ltr:-right-6 rtl:-left-6 z-2"
        :style="`top: ${arrowsTopPixels}px`">
        <img class="h-10 w-10 md:h-12 md:w-12 rounded-full border border-blue-300 md:border-0 shadow-ts3"
          src="../../assets/img/next-arrow-2.svg" />
      </div>
    </div>
    <div v-if="navPosition === 'bottom' && showNavigationBar"
      class="w-11/12 lg:w-auto m-auto flex ltr:lg:ml-8 rtl:lg:mr-8 mt-4 pb-3">
      <div class="w-1/2 flex space-x-2 rtl:space-x-reverse">
        <div @click="scrollLeft()" class="cursor-pointer">
          <img class="h-6 w-6" src="../../assets/img/arrow-previous.svg" />
        </div>
        <div @click="scrollRight()" class="cursor-pointer">
          <img class="h-6 w-6" src="../../assets/img/arrow-next.svg" />
        </div>
      </div>
      <div class="w-1/2 ltr:text-right rtl:text-left ltr:md:pr-0 ltr:lg:pr-8 rtl:md:pl-0 rtl:lg:pl-8 hidden md:block">
        <router-link :to="'/' + Language + `/${showMoreRoute}`" class="font-semibold text-gray-900 text-sm">{{
          $t('see_more') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "Carousel",
  components: {},
  props: {
    navPosition: {
      type: String, // "center" | "bottom"
      default: 'center' // Default to 'center' if not provided
    },
    showNavigationBar: {
      type: Boolean,
      default: true // Default to true if not provided
    },
    showMoreRoute: {
      type: String, // Route the showMore will redirect, ex: 'trading-accounts'
      default: "" // Default to '' if not provided
    },
    movementSize: {
      type: Number, // How much pixels will scroll when clicking scroll left or right
      default: 320 // Default to 320 if not provided
    }
  },
  data() {
    return {
      arrowsTopPixels: 200,
      showArrows: true,
      elementWidth: 0
    }
  },
  mounted() {
    this.dragContainer('#taContainer')
    this.calculateArrowsTopPixels()
    // Measure the width initially when the component is mounted
    this.updateWidth();

    // Observe the element for size changes
    this.initResizeObserver();

    // Recalculate on window resize
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    // Clean up observers and event listeners
    this.resizeObserver.disconnect();
    window.removeEventListener("resize", this.updateWidth);
  },
  watch: {
    // Watch for any reactive changes affecting element size
    elementWidth(newWidth) {
      let allItems = []
      let allItemsLength = 0
      if (this.$refs.itemsRef.childNodes.length > 1) {
        allItems = this.$refs.itemsRef.childNodes
      } else if (this.$refs.itemsRef.childNodes.length === 1) {
        if (this.$refs.itemsRef.childNodes[0].childNodes.length === 1) {
          allItems = this.$refs.itemsRef.childNodes[0].childNodes[0].childNodes
        } else allItems = this.$refs.itemsRef.childNodes[0].childNodes
      }
      if (allItems.length > 0) {
        allItems.forEach(element => {
          if (element.offsetWidth) {
            allItemsLength += element.offsetWidth + 16
          }
        });
        allItemsLength = allItemsLength - 16
        let updatedWidth = newWidth
        if (allItemsLength > updatedWidth) {
          this.showArrows = true
        } else {
          this.showArrows = false
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    })
  },
  methods: {
    /**
     * Function to calculate the top space of the arrow icons so they will be on center vertically
     */
    calculateArrowsTopPixels() {
      let height = document.getElementById('taContainer')?.offsetHeight
      this.arrowsTopPixels = height / 2 - 45
    },
    /**
     * Function to scroll left
     */
    scrollLeft() {
      this.navPosition === 'center' ? document.getElementById('contentContainer').scrollLeft -= this.movementSize : document.getElementById('taContainer').scrollLeft -= this.movementSize
    },
    /**
     * Function to scroll right
     */
    scrollRight() {
      this.navPosition === 'center' ? document.getElementById('contentContainer').scrollLeft += this.movementSize : document.getElementById('taContainer').scrollLeft += this.movementSize
    },
    /**
     * Function to update the width of the element
     */
    updateWidth() {
      const element = this.$refs.itemsRef;
      if (element) {
        const style = getComputedStyle(element);
        this.elementWidth = element.scrollWidth
          + parseFloat(style.borderLeftWidth)
          + parseFloat(style.borderRightWidth);
      }
    },
    /**
     * Function to Set up ResizeObserver to listen to size changes
     */
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateWidth();
      });
      this.resizeObserver.observe(this.$refs.itemsRef);
    },
  },
}
</script>

<style scoped lang="css">
#contentContainer::-webkit-scrollbar,
#trackingCarouselContainer::-webkit-scrollbar {
  display: none;
}

#boxes::-webkit-scrollbar,
#promotionsContainer::-webkit-scrollbar {
  display: none;
}

#taContainer::-webkit-scrollbar,
#boxes::-webkit-scrollbar {
  /* @apply h-1; */
  height: 4px;
  width: 4px;
}

/* Track */
#taContainer::-webkit-scrollbar-track {
  /* @apply bg-gray-400 rounded-xl; */
  background: #e9edf4;
  border-radius: 12px;
}

#boxes::-webkit-scrollbar-track {
  /* @apply bg-gray-400 rounded-xl; */
  background: #f8f9fd;
  border-radius: 12px;
}

/* Handle */
#taContainer::-webkit-scrollbar-thumb,
#boxes::-webkit-scrollbar-thumb {
  /* @apply bg-blue rounded-xl; */
  background: #2b63e3;
  border-radius: 12px;
}

#taContainer {
  scroll-behavior: smooth;
}

#taContainer.active {
  scroll-behavior: auto;
}

.switch_mode .slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 0;
  bottom: 0;
  background-color: #2b63e3;
  transition: 0.4s;
  border-radius: 50%;
}

.switch_mode input:checked+.slider {
  background-color: #cfd9de;
}

.switch_mode input:focus+.slider {
  box-shadow: 0 0 1px #cfd9de;
}

.switch_mode input:checked+.slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

#contentContainer,
#trackingCarouselContainer {
  scroll-behavior: smooth;
}

#contentContainer.active {
  scroll-behavior: auto;
}
</style>
